import {  Component } from '@angular/core';
import { ProvidersService } from 'fccore2'; 
import { FcinputComponent } from '../fcinput';
import { Sysappfields } from 'fccore2';
@Component({
    selector: 'fc-table',
    template: `
    <nz-table #nzTable [nzData]="fcOption.data" [nzIsPagination]="fcOption.enablePage">
        <thead nz-thead>
          <tr>
            <th *ngFor="let field of fcOption.fields" nz-th><span>{{field.FIELDNAME}}</span></th>
          </tr>
        </thead>
      <tbody nz-tbody>
        <tr nz-tbody-tr *ngFor="let data of nzTable.data">
            <td nz-td *ngFor="let field of fcOption.fields" nz-th>{{data[field.FIELDCODE]}}</td>
        </tr>
      </tbody>
    </nz-table>
    `,
    styles: [`
    `]
})
export class FctableComponent extends FcinputComponent {
    constructor(public provider: ProvidersService) {
        super(provider,'fc-table');
        this.fcOption = { fields: [], data: [] };
    }
    _search(event: any): void {
        this.event( 'search', event )
    }
    _afterParentInit() {
        if (this.fcOption || this.fcOption.field || this.fcOption.field.length === 0) {
            this.fcOption.fields = this.fcApp.SYSAPPFIELDS;
        }
        if (this.fcOption.enablePage === undefined) {
            this.fcOption.enablePage = false;
        }
        if (this.fcOption.data === undefined || this.fcOption.data.length === 0) {
            this.pushDestroy(this.appService.findWithQuery(this.fcAppid, {}).subscribe(result => {
                if (result.CODE === '0') {
                    this.fcOption.data = result.DATA;
                }
            }));
        }
    }
}
export interface FctableOption {
    fields: Sysappfields[];
    data: any[];
    enablePage: boolean;
}